import { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { getCurrentAccount, getPayerAccount, getSelectedPrimaryAccount, getSelectedSecondaryAccount } from "./Selectors";
import { getPayerDetailsBuilder } from "../../actions/InvoiceActions";
import _ from 'lodash';
import { getPaymentMethods } from "../../requests/InvoiceRequests";
import { SET_PAYMENT_METHODS } from "../../constants/ActionTypes";
import * as React from "react";
import * as appConstants from "../../constants/ApplicationConstants";
import { usePrevious } from "../../hooks";

export const PayerDetailsContext = React.createContext([]);

function PayerDetailsDataManager(props) {
    const selectedPayer = props.accountType === appConstants.SOLD_TO_COMPARE ? props.selectedSecondaryAccount : props.selectedPrimaryAccount;
    const prevAmount = usePrevious({ selectedPayer });

    useEffect(() => {
        if (prevAmount != undefined) {
            if (props.selectedPrimaryAccount !== null && !_.isEqual(prevAmount.selectedPayer, selectedPayer)) {
                getPayerDetailsBuilder(props.dispatch, props.selectedPrimaryAccount, props.selectedSecondaryAccount, props.accountType);
                getPaymentMethods(props.currentAccount).then((paymentMethods) => {
                    props.dispatch({ type: SET_PAYMENT_METHODS, payload: paymentMethods }, () => { });
                });
            }
        }
    }, [
        props.selectedSecondaryAccount,
        props.selectedPrimaryAccount,
        props.accountType,
        props.currentAccount,
    ]);

    return <PayerDetailsContext.Provider value={true}>
        {props.render}
    </PayerDetailsContext.Provider>;
}

export default connect((state, props) => {
    return {
        selectedPrimaryAccount: getSelectedPrimaryAccount(state, props),
        selectedSecondaryAccount: getSelectedSecondaryAccount(state, props),
        accountType: state.user_options.accountType,
        currentAccount: getCurrentAccount(state, props),
    }
})(PayerDetailsDataManager);
